import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useMediaQuery } from 'react-responsive'
import { reduxForm, Field } from "redux-form";
import { NotificationManager } from "react-notifications";

import { sendForgotPasswordCredentials } from "../../store/actions";
import PlaceholderImage from "../../sharedComponents/placeholderImage";
import Logo from "../../assets/images/logo-color.png";
import { FormField } from "../../sharedComponents/formField";
import { required, email } from "../../constants/formValidators";

import "./Session.scss";

const ForgotPassword = ({ history, handleSubmit, sendForgotPasswordCredentials }) => {

	const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });

	const submitForgotPassword = (values) => {
		const successHandler = (event) => {
			NotificationManager.success(`If an account exists for ${values.email}, password reset instructions will be sent.`, "", 5000);
			history.push("/signin");
		};
		const errorHandler = (event) => {
			event && event.error_code === "VALIDATION_ERROR" && NotificationManager.error(event.errors.email, "", 5000);
		};
		sendForgotPasswordCredentials(values, successHandler, errorHandler);
	};

	return (
		<section className="page page-session">
			<div className="session-wrap">
				{isDesktop ? (
					<div className="session-left">
						<div className="left-data-container">
							<h2 className="normal">Membership with benefits!</h2>
							<p>Access is FREE for active Medi-Weightloss® patients and includes:</p>
							<ul className="check-list">
								<li>Your weight statistics and progress</li>
								<li>Food and supplement journal</li>
								<li>Approved recipes</li>
								<li>Exercise plans and tracker </li>
								<li>Customizable profile</li>
								<li>Appointment reminder</li>
								<li>Articles, information, tips, and more!</li>
							</ul>
						</div>
					</div>) : null}
				<div className="session-right">
					<PlaceholderImage src={Logo} />
					<h3 className="text-center text-primary-dark mt-4 mb-3">
						Password Reset
					</h3>
					<form className="m-0" onSubmit={handleSubmit(submitForgotPassword)}>
						<Field
							label="Email address"
							name="email"
							formGroupClass="no-label mt-4"
							type="text"
							component={FormField}
							validate={[required, email]}
						/>
						<button type="submit" className="w-100 btn btn-primary btn-lg text-uppercase">
							Submit
						</button>
					</form>
					<div className="text-right mt-2 mb-5">
						<Link to="/signin" className="text-secondary">
							Login
						</Link>
					</div>
					{/* <p className="text-center mb-5">
						If you don&apos;t remember your email address, you can simply
						<Link className="text-primary-dark ml-2 mr-2" to="/register">
							re-register using your registration code
						</Link>
						on your receipt!
					</p> */}
				</div>
			</div>
		</section>
	);
};

const mapDispatchToProps = {
	sendForgotPasswordCredentials
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "ForgotPasswordForm"
	})(ForgotPassword)
);
